import { apiClient, tokenStorage } from './api'
import type {
  ArtefactTemplate,
  CollectorSettings,
  CreateArtefactTemplateInput,
  TestBuildInput,
  TestBuildResult,
  UpdateArtefactTemplateInput,
  UpsertCollectorSettingsInput,
} from '../types/artefact-templates'

import { API_BASE_URL } from './api-base-url'
const BASE_PATH = '/admin/velociraptor/artefact-templates'

export async function listPlatformTemplates(): Promise<ArtefactTemplate[]> {
  return apiClient.get<ArtefactTemplate[]>(BASE_PATH)
}

export async function getPlatformTemplate(templateId: string): Promise<ArtefactTemplate> {
  return apiClient.get<ArtefactTemplate>(`${BASE_PATH}/${templateId}`)
}

export async function createPlatformTemplate(
  input: CreateArtefactTemplateInput
): Promise<ArtefactTemplate> {
  return apiClient.post<ArtefactTemplate>(BASE_PATH, input)
}

export async function updatePlatformTemplate(
  templateId: string,
  input: UpdateArtefactTemplateInput
): Promise<ArtefactTemplate> {
  return apiClient.put<ArtefactTemplate>(`${BASE_PATH}/${templateId}`, input)
}

export async function deletePlatformTemplate(templateId: string): Promise<void> {
  await apiClient.delete(`${BASE_PATH}/${templateId}`)
}

export async function upsertPlatformCollectorSettings(
  templateId: string,
  input: UpsertCollectorSettingsInput
): Promise<CollectorSettings> {
  return apiClient.put<CollectorSettings>(`${BASE_PATH}/${templateId}/collector-settings`, input)
}

export async function triggerPlatformTestBuild(
  templateId: string,
  input: TestBuildInput
): Promise<TestBuildResult> {
  return apiClient.post<TestBuildResult>(`${BASE_PATH}/${templateId}/test-build`, input)
}

export async function downloadPlatformTestBuild(flowId: string): Promise<void> {
  const token = tokenStorage.getAccessToken()
  const url = `${API_BASE_URL}${BASE_PATH}/test-builds/${encodeURIComponent(flowId)}/download`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token ?? ''}`,
    },
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(error || 'Failed to download collector')
  }

  const contentDisposition = response.headers.get('Content-Disposition')
  let filename = 'collector'
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/)
    if (match) {
      filename = match[1] ?? 'collector'
    }
  }

  const blob = await response.blob()
  const downloadUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = downloadUrl
  link.download = filename
  document.body.append(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(downloadUrl)
}
